import { AdditionalIcon } from "../shared/additionalIcon/additionalIcon";
import { ReactComponent as Close } from '../../icons/close.svg';
import { CloseButtonProps } from "react-toastify";

const CloseButton = (props: CloseButtonProps) => (
    <div className="Toastify__close-button" onClick={props.closeToast} >
        {AdditionalIcon(Close)}
    </div>
);

export default CloseButton;